export default "__VITE_ASSET__CHY$T8Ko__"